import React from 'react';
import moment from 'moment';
import borderLeftStyles from '../CustomRow/BorderLeft.module.scss';
import BorderLeft from '../CustomRow/BorderLeft';
import SortableSymbol from '../customheader/SortableSymbol';
import TitleCell from '../../impactanalysis/impactsummary/imimpactsummary/CustomCells/TitleCell';

const RenderTitleCell = (row, value) => (
    <TitleCell
        title={ row.original.title }
        value={ value || value === 0 ? value.toLocaleString() : '' }
        alignRight
        titleRow={ row.original.titleRow === true }
        error={ row.original.error }
    />
);

const gridProps = header => header.column.getGridProps();

const makeColumns = (useDollars = false) => {
    const currencyString = useDollars ? 'Usd' : 'Eur';
    return (
        [
            {
                title: 'CSA',
                id: 'csa',
                type: 'string',
                minWidth: 70,
                visible: true,
                draggable: false,
                hideable: false,
                noPadding: true,
                sortable: true,
                renderCell: (row) => {
                    if (row.original.reconciliationStatus === 'Dispute') {
                        return (
                            <BorderLeft
                                dispute
                                styles={ borderLeftStyles }
                                word={ row.value }
                            />
                        );
                    } if (row.original.reconciliationStatus === 'Discrepancy') {
                        return (
                            <BorderLeft
                                discrepancy
                                styles={ borderLeftStyles }
                                word={ row.value }
                            />
                        );
                    }
                    return (
                        <BorderLeft
                            styles={ borderLeftStyles }
                            word={ row.value }
                        />
                    );
                }
            },
            {
                title: 'Business Date',
                id: 'businessDate',
                type: 'string',
                visible: true,
                minWidth: 120,
                draggable: false,
                hideable: true,
                sortable: true,
                renderCell: row => moment(row.value).format('DD MMM YYYY')
            },
            {
                title: 'Counterparty',
                id: 'counterparty',
                type: 'string',
                visible: true,
                minWidth: 300,
                draggable: false,
                hideable: false,
                sortable: true
            },
            {
                title: 'IM Threshold Collect',
                id: `imThresholdCollect${currencyString}`,
                idWithoutCurrency: 'imThresholdCollect',
                type: 'number',
                visible: false,
                minWidth: 130,
                draggable: false,
                hideable: true,
                sortable: true,
                hasSymbol: true,
                Header: header => (
                    <SortableSymbol
                        gridStyles={ header.column.getGridProps().styles }
                        title={ header.column.title }
                        symbol={ header.column.getGridProps().symbol }
                        alignRight
                    />
                ),
                renderCell: row => RenderTitleCell(row, row.value)
            },
            {
                title: 'IM Threshold Post ',
                id: `imThresholdPost${currencyString}`,
                idWithoutCurrency: 'imThresholdPost',
                type: 'number',
                visible: false,
                minWidth: 130,
                draggable: false,
                hideable: true,
                sortable: true,
                hasSymbol: true,
                Header: header => (
                    <SortableSymbol
                        gridStyles={ header.column.getGridProps().styles }
                        title={ header.column.title }
                        symbol={ header.column.getGridProps().symbol }
                        alignRight
                    />
                ),
                renderCell: row => RenderTitleCell(row, row.value)
            },
            {
                title: 'Real IM Pledge',
                id: `imPledgorPayment${currencyString}`,
                idWithoutCurrency: 'imPledgorPayment',
                type: 'number',
                visible: true,
                minWidth: 150,
                draggable: true,
                hideable: true,
                sortable: true,
                hasSymbol: true,
                Header: header => (
                    <SortableSymbol
                        gridStyles={ gridProps(header).styles }
                        title={ header.column.title }
                        symbol={ gridProps(header).symbol }
                        alignRight
                    />
                ),
                renderCell: row => RenderTitleCell(row, row.value)
            },
            {
                title: 'IM Pledge ',
                id: `imPledge${currencyString}`,
                idWithoutCurrency: 'imPledge',
                type: 'number',
                visible: true,
                minWidth: 120,
                draggable: true,
                hideable: true,
                sortable: true,
                hasSymbol: true,
                Header: header => (
                    <SortableSymbol
                        gridStyles={ gridProps(header).styles }
                        title={ header.column.title }
                        symbol={ gridProps(header).symbol }
                        alignRight
                    />
                ),
                renderCell: row => RenderTitleCell(row, row.value)
            },
            {
                title: 'IM Receive',
                id: `imReceive${currencyString}`,
                idWithoutCurrency: 'imReceive',
                type: 'number',
                visible: true,
                minWidth: 120,
                draggable: true,
                hideable: true,
                sortable: true,
                hasSymbol: true,
                Header: header => (
                    <SortableSymbol
                        gridStyles={ gridProps(header).styles }
                        title={ header.column.title }
                        symbol={ gridProps(header).symbol }
                        alignRight
                    />
                ),
                renderCell: row => RenderTitleCell(row, row.value)
            }
        ]
    );
};

export default makeColumns;
